module.exports = __webpack_public_path__ + "static/strategic-consulting-59e706a07632e7f8cba7886a871250f0.jpg";